/**
 * Created by Allan on 2025/05/13.
 * Contact 84880528@qq.com.
 */
import { Base64 } from 'js-base64';
import getQueryVariable from '@/smspromo/services/getQueryVariable';
let newTitle=Base64.decode(getQueryVariable('appname'));
console.log('newTitle',newTitle)
export default[
	//首页
	{
		path:'/index',
		name:'index',
		meta:{
			title:newTitle,
		},
		component: resolve => require(['@/smspromo/views/home/index.vue'], resolve)
	},
]



// WEBPACK FOOTER //
// ./src/smspromo/router/map/peruorder.js